<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t("components.terminalForm.title") }}</span>
          </div>
          <h2></h2>
          <div class="ui grid stackable main_container">
            <div class="sixteen wide column">
              <TerminalForm></TerminalForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import TerminalForm from '@/components/TerminalForm.vue';

export default {
  name: 'Terminal',
  components: {
    TerminalForm
  },
  mounted: function () {
    $('.ui.sidebar').sidebar('hide');
  }
};
</script>
